export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7611.0062d331.jpg";